import { CiCircleRemove } from "react-icons/ci";
import Swal from "sweetalert2";
import { DeleteBeneficiary } from "../../services/beneficiaries";

const USER_ICON = "/images/user.png";

// Map Persian bank_label keywords to SVG files in /public/banks
const BANK_KEYWORDS = [
  ["اقتصاد نوین", "Eghtesad_Novin.svg"],
  ["توسعه تعاون", "Tosee_Taavon.svg"],
  ["توسعه صادرات", "Tosee.svg"],
  ["خاورمیانه", "Khavar_Mianeh.svg"],
  ["خاور میانه", "Khavar_Mianeh.svg"],
  ["ایران زمین", "Iran_Zamin.svg"],
  ["مهر ایران", "Mehr_Iran.svg"],
  ["قرض الحسنه مهر", "Mehr_Iran.svg"],
  ["پست بانک", "Postbank.svg"],
  ["پستبانک", "Postbank.svg"],
  ["کارآفرین", "Karafarin.svg"],
  ["کار افرین", "Karafarin.svg"],
  ["حکمت ایرانیان", "Hekmat.svg"],
  ["بانک حکمت", "Hekmat.svg"],
  ["رفاه کارگران", "Refah.svg"],
  ["بانک رفاه", "Refah.svg"],
  ["پارسیان", "Parsian.svg"],
  ["پاسارگاد", "Pasargad.svg"],
  ["کشاورزی", "Keshavarzi.svg"],
  ["گردشگری", "Gardeshgari.svg"],
  ["صادرات", "Saderat.svg"],
  ["قوامین", "Ghavamin.svg"],
  ["مرکزی", "Bank_Markazi.svg"],
  ["رسالت", "Resalat.svg"],
  ["سرمایه", "Sarmayeh.svg"],
  ["آینده", "Ayandeh.svg"],
  ["تجارت", "Tejarat.svg"],
  ["مسکن", "Maskan.svg"],
  ["انصار", "Ansar.svg"],
  ["کاسپین", "Caspian.svg"],
  ["سامان", "Saman.svg"],
  ["ملت", "Mellat.svg"],
  ["ملل", "Melall.svg"],
  ["ملی", "Melli.svg"],
  ["سپه", "Sepah.svg"],
  ["سینا", "Sina.svg"],
  ["شهر", "Shahr.svg"],
  ["بانک دی", "Dey.svg"],
  ["بانک توسعه", "Tosee.svg"],
];

const normalizeFa = (text) =>
  String(text)
    .replace(/ي/g, "ی")
    .replace(/ك/g, "ک")
    .replace(/‌/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const getPersonOrBankIcon = (bankLabel) => {
  if (!bankLabel) return USER_ICON;

  const label = normalizeFa(bankLabel);
  const match = BANK_KEYWORDS.find(([keyword]) =>
    label.includes(normalizeFa(keyword))
  );

  return match ? `/banks/${match[1]}` : USER_ICON;
};

export const ListPepole = (props) => {
    
    const removeUser = (userId, event) => {
        event.stopPropagation();
        Swal.fire({
            title: "<strong>آیا از حذف  اطمینان دارید ؟</strong>",
            icon: "info",
            html: `
              بعد از حذف کاربر امکان بازگشت وجود ندارد
            `,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: `
              <i class="fa fa-thumbs-up"></i> حذف شود!
            `,
            confirmButtonAriaLabel: "Thumbs up, great!",
            cancelButtonText: `
              <i class="fa fa-thumbs-down"></i> انصراف
            `,
            cancelButtonAriaLabel: "Thumbs down"
          }).then(async (result) => {
            if (!result.isConfirmed) return;

            try {
                await DeleteBeneficiary(userId);
                props.onDeleted?.(userId);
            } catch (error) {
                console.log(error);
            }
        });
    }

 
    return (
        props.pepole?.map(item => 
            {
              if (item.status == 1) {
                return (
                  <div className={`pepole w-full flex items-center justify-between border rounded-md p-2 my-2 cursor-pointer  ${
                    props.isDark ? "card" : "card2"
      }`} onClick={()=>props.handlSetInputs(item)} key={item.id}>
                <div className="img-pepole">
                    <img
                      src={getPersonOrBankIcon(item.bank_label)}
                      className="dark:bg-white rounded-full w-6 h-6 object-contain"
                      alt={item.bank_label || ""}
                      width="24px"
                      height="24px"
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = USER_ICON;
                      }}
                    />
                </div>
                <div className="info-pepole">
                <span>
                {(() => {
                  const name = item.name;
                  const lastName = item.lastname;
                  if (!name && !lastName) return 'نامشخص';
                  if (name === lastName) return lastName || name;
                  return `${name || ''} ${lastName || ''}`.trim();
                })()}
              </span>
                </div>
                <div>
                <CiCircleRemove size={"24px"} onClick={(event) => removeUser(item.id, event)}/>
                </div>
            </div>
                )
              }
            }
        )
    )
}